import { useEffect, memo, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getCurrency, getTokens, setCurrentTrade } from '../redux/exchange/action'
import { getPeers } from '../redux/node/action'
import { getPairs } from '../redux/tradePairs/action'
import { getFees } from '../redux/fees/action'
import { getAccount } from '../redux/account/action'
import { getIpValidation } from '../redux/global/action'
import { fetchI18n } from '../i18n/reducer'
import { useCurrentTokenType } from '../utils/tokenTypes'

const CommonDataProvider = memo(() => {
  const dispatch = useDispatch()
  const tokenType = useCurrentTokenType()
  const currentTrade = useSelector(state => state.exchange.currentTrade)
  const allPairs = useSelector(state => state.tradePairs.pairs)
  const filteredPairs = useMemo(() => allPairs.filter(it => it.tokenType === tokenType), [
    allPairs,
    tokenType,
  ])
  useEffect(() => {
    dispatch(getCurrency())
    dispatch(getPeers())
    dispatch(getFees())
    dispatch(getTokens())
    dispatch(getPairs())
    dispatch(getIpValidation())
    dispatch(fetchI18n())

    let user = sessionStorage.getItem('user')
    user = (user && JSON.parse(user)) || {}

    if (user.address) {
      dispatch(getAccount(user.address))
    }
  }, [dispatch])

  useEffect(() => {
    if (!currentTrade && filteredPairs.length > 0) {
      const defaultPair = filteredPairs[0]
      const firstTrade = `${defaultPair.base_asset_symbol}_${defaultPair.quote_asset_symbol}`
      dispatch(setCurrentTrade(firstTrade))
    }
  }, [dispatch, currentTrade, filteredPairs])

  return null
})

export default CommonDataProvider
